// components/Button.jsx
import React, { memo } from 'react';
import { Button as AntButton } from "antd"

const Button = ({
    children,
    className = '!bg-primaryColor text-white',
    loading = false,
    disabled = false,
    onClick,
    type = 'button',
    icon,
    iconPosition = 'left',
    loadingText,
    buttonText,
    ...props
}) => {
    return (
        <AntButton
            style={{
                height: '38px',
            }}
            type={type}
            className={`!bg-primaryColor text-white ${className}`}
            disabled={disabled || loading}
            onClick={onClick}
        >
            {buttonText}
        </AntButton>
    );
};

export default memo(Button);
